import type React from 'react';
import { ShiftContextProvider, useShiftState } from './useShift';

type ShiftProviderProps = {
    children: React.ReactNode;
};

/**
 * Provides the shift open/close state to the POS. Mirrors the page-provider
 * pattern — the container mounts this inside `SellerProvider` so the navbar
 * shift button and (later) the cash-count modal read shared state via
 * `useShift()`.
 */
export const ShiftProvider: React.FC<ShiftProviderProps> = ({ children }) => {
    const value = useShiftState();
    return (
        <ShiftContextProvider value={value}>{children}</ShiftContextProvider>
    );
};
